"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.imgGen.name': 'Generowanie Obrazów',
    'tools.imgGen.description': 'Generuj obrazy z opisów tekstowych',
};
